"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.ScreenWaitlistAnalyticsEvent = exports.ScreenReviewCostBreakdownAnalyticsEvent = exports.ScreenPaymentReviewAnalyticsEvent = exports.ScreenOnboardingCongratsAnalyticsEvent = exports.ScreenOnboardingCompletedAnalyticsEvent = exports.ScreenMoveInOnboardingLandingAnalyticsEvent = exports.ScreenManualCostEntryAnalyticsEvent = exports.LandingLearnMoreClickedAnalyticsEvent = exports.LandingGetStartedClickedAnalyticsEvent = exports.FetchCostBreakdownSuccAnalyticsEvent = exports.FetchCostBreakdownErrorAnalyticsEvent = exports.FetchCostBreakdownAnalyticsEvent = exports.EditCostsClickedAnalyticsEvent = exports.ChangeCardClickedAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when user lands on the Move-In Landing Screen
 */
var ScreenMoveInOnboardingLandingAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_move_in_onboarding_landing');
exports.ScreenMoveInOnboardingLandingAnalyticsEvent = ScreenMoveInOnboardingLandingAnalyticsEvent;
/**
 * Triggers when user lands on "Your move-in cost breakdown" (if bill found) as part of the Move-In Onboarding Flow
 */
var ScreenReviewCostBreakdownAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_review_cost_breakdown');
exports.ScreenReviewCostBreakdownAnalyticsEvent = ScreenReviewCostBreakdownAnalyticsEvent;
/**
 * Triggers when user lands on "Enter your move-in costs for X" (if bill not found) as part of the Move-In Onboarding Flow
 */
var ScreenManualCostEntryAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_manual_cost_entry');
exports.ScreenManualCostEntryAnalyticsEvent = ScreenManualCostEntryAnalyticsEvent;
/**
 * Triggers when user lands on "Make one-time payment" page to review Move-In costs along with payment method as part of the Move-In Onboarding Flow
 */
var ScreenPaymentReviewAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_payment_review');
exports.ScreenPaymentReviewAnalyticsEvent = ScreenPaymentReviewAnalyticsEvent;
/**
 * Triggers when user lands on "Waitlist" page as part of the Move-In Onboarding Flow
 */
var ScreenWaitlistAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_waitlist');
exports.ScreenWaitlistAnalyticsEvent = ScreenWaitlistAnalyticsEvent;
/**
 * Triggers when user lands on "Move-In Complete" screen as part of the Move-In Onboarding Flow
 */
var ScreenOnboardingCompletedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_onboarding_completed');
exports.ScreenOnboardingCompletedAnalyticsEvent = ScreenOnboardingCompletedAnalyticsEvent;
/**
 * Triggers when user lands on "Success" page to indicate payment success as part of the Move-In Onboarding Flow
 */
var ScreenOnboardingCongratsAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_onboarding_congrats');
exports.ScreenOnboardingCongratsAnalyticsEvent = ScreenOnboardingCongratsAnalyticsEvent;
/**
 * Triggers when user clicks on "Get started" on the Move-In Landing Screen
 */
var LandingGetStartedClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('landing_get_started_clicked');
exports.LandingGetStartedClickedAnalyticsEvent = LandingGetStartedClickedAnalyticsEvent;
/**
 * Triggers when user clicks on "Learn more" on the Move-In Landing Screen
 */
var LandingLearnMoreClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('landing_learn_more_clicked');
exports.LandingLearnMoreClickedAnalyticsEvent = LandingLearnMoreClickedAnalyticsEvent;
/**
 * Triggers when user clicks on "Change" on the "Make one-time payment" page to switch to a different card as part of the Move-In Onboarding Flow
 */
var ChangeCardClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('change_card_clicked');
exports.ChangeCardClickedAnalyticsEvent = ChangeCardClickedAnalyticsEvent;
/**
 * Triggers when user clicks on "Edit" on the "Make one-time payment" page to modify Move-In costs as part of the Move-In Onboarding Flow
 */
var EditCostsClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('edit_costs_clicked');
exports.EditCostsClickedAnalyticsEvent = EditCostsClickedAnalyticsEvent;
/**
 * Triggers when we attempt to fetch the customer's Move-In Cost Breakdown information
 */
var FetchCostBreakdownAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('fetch_cost_breakdown');
exports.FetchCostBreakdownAnalyticsEvent = FetchCostBreakdownAnalyticsEvent;
/**
 * Triggers when we successfully fetch the customer's Move-In Cost Breakdown information and navigate to the automated cost breakdown screen
 */
var FetchCostBreakdownSuccAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('fetch_cost_breakdown_succ');
exports.FetchCostBreakdownSuccAnalyticsEvent = FetchCostBreakdownSuccAnalyticsEvent;
/**
 * Triggers when we fail to fetch the customer's Move-In Cost Breakdown information and navigate to the manual cost entry screen
 */
var FetchCostBreakdownErrorAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('fetch_cost_breakdown_error');
exports.FetchCostBreakdownErrorAnalyticsEvent = FetchCostBreakdownErrorAnalyticsEvent;
